import { animate, style, transition, trigger } from '@angular/animations';

export const FIELD_ERROR_ANIMATION = [
  trigger('fieldError', [
    transition(':enter', [
      style({ transform: 'translateY(-75%)', opacity: '0' }),
      animate('.6s cubic-bezier(0.55, 0.31, 0.15, 0.93)', style({ transform: 'translateY(0%)', opacity: '1' }))
    ]),
    transition(':leave', [
      animate('0.3s cubic-bezier(0.55, 0.31, 0.15, 0.93)', style({ transform: 'translateY(50%)', opacity: '0' }))
    ])
  ])
];
